// Single job: own safe lookup of sportsbook ids, for the client and for api/ (the
// import-confirm allow-list). SPORTSBOOKS in constants.js stays the one list; this
// module never copies it. Lookups are own-key only: a stored value like '__proto__'
// must never resolve to Object.prototype (#1116 -- that crashed The Bookies board).
// Explicit '.js': api/ loads this under Node ESM, which cannot resolve an extensionless
// specifier (Ultron F4). CRA accepts it too.
import { SPORTSBOOKS } from './constants.js';

const BY_ID = new Map(SPORTSBOOKS.map((s) => [s.id, s]));

export const SPORTSBOOK_IDS = new Set(BY_ID.keys());

export function isKnownSportsbookId(id) {
  return typeof id === 'string' && BY_ID.has(id);
}

export function getSportsbook(id) {
  return isKnownSportsbookId(id) ? BY_ID.get(id) : null;
}

// #1199: what a card shows for a stored sportsbook. An unregistered or legacy value
// ('unknown', 'loadtest', 'draftkings') gets a neutral label, never the first registry
// entry (that rendered every such bet as FanDuel, in FanDuel's colour). color is null so
// the caller picks its own neutral token.
export const UNKNOWN_SPORTSBOOK = Object.freeze({ id: null, name: 'Sportsbook', color: null });

export function sportsbookForDisplay(id) {
  return getSportsbook(id) || UNKNOWN_SPORTSBOOK;
}
